// Placeholder shrine reward definitions.
//
// The user requested that the *effect list* can be done later.
// This file provides a small, safe default reward per tier so the shrine feature
// is visibly functional in the demo.
//
// Replace / expand these later with your full design.

/**
 * @typedef {Object} ShrineReward
 * @property {'combat'|'resource'|'relic'} type
 * @property {string} label
 * @property {string} [perk]   // for type='combat'
 * @property {number} [amount]
 * @property {string} [kind]   // for type='resource'
 * @property {{common:number,uncommon:number,rare:number}} [rarityWeights] // for type='relic'
 */

/**
 * Returns a small default reward that doesn't require adding new systems.
 * You can swap this later for a full reward table.
 *
 * @param {'common'|'rare'|'mythic'} tier
 * @returns {ShrineReward}
 */
export function getPlaceholderShrineReward(tier) {
  if (tier === 'rare') {
    return {
      type: 'combat',
      perk: 'negateNextDamage',
      amount: 1,
      label: 'Blessing: Negate the next instance of damage in your next combat.',
    };
  }

  if (tier === 'mythic') {
    return {
      type: 'relic',
      rarityWeights: { common: 0, uncommon: 0, rare: 1 },
      label: 'Mythic Boon: Gain a rare trinket.',
    };
  }

  // common
  return {
    type: 'combat',
    perk: 'nextCost0',
    amount: 1,
    label: 'Blessing: Your first card played in the next combat costs 0.',
  };
}
